// @ts-nocheck
import {
  CFG,
  BOT_SKILLS,
  normalizeBotSkill,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SHOP_CATEGORY_ORDER,
  SPELLS,
  SPELLS_IN_CATEGORY,
  shopCategoryLabel,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  loadCreatePrefs,
  loadMmPrefs,
  MM_FFA_ALL_SIZES,
  MM_PVE_ALL_SIZES,
  MM_QUICK_MATCH_SIZES,
  MM_TEAM_ALL_SIZES,
  mmFfaSizesIsAny,
  mmPveSizesIsAny,
  mmTeamSizesIsAny,
  rebuildKeyToSlot,
  saveCreatePrefs,
  saveKeybinds,
  saveMmPrefs,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  PASSIVE_TREES,
  spellPassiveSummary,
  spellUnlockSp,
  teamColor,
  equippedTitleId,
} from "../data";
import { MM_QUEUE_TIP_MS, pickMmQueueTip } from "../mm-queue-tips";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
  wireDiscordInviteLinks,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  spellIconInner,
} from "../spell-icons";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  copyInviteLink,
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";
import { refreshSpellCatalogSearch } from "./spell-catalog-search";

Game.prototype.setupMenuUI = function () {
    const $ = (id) => document.getElementById(id);
    wireDiscordInviteLinks();
    const nameInput = $("nameInput");
    try { nameInput.value = localStorage.getItem("warlock_name") || ""; } catch (e) {}

    this.setupAudioUI($);
    this.startPresenceHeartbeat();
    this.startPlayersOnlinePoll();
    this.ensureMenuNet();
    setupUiButtonSounds();

    // Controls help on home re-renders when keybinds change (see renderKeyReferences).

    // Home hub navigation: pick a way to play, then drill into a focused view.
    $("goOnlineBtn").onclick = () => { Sound.resume(); Sound.ui(); this.saveName(); this.showFind(); };
    $("homeQuickMatchBtn").onclick = () => { Sound.ui(); this.startQuickMatch(); };
    $("goSoloBtn").onclick = () => { Sound.resume(); Sound.ui(); this.saveName(); this.showSolo(); };
    $("goSandboxBtn").onclick = () => { Sound.resume(); this.saveName(); this.startSandbox(); };
    $("findBack").onclick = () => { Sound.ui(); this.showHome(); };
    $("goMatchmakerBtn").onclick = () => { Sound.resume(); Sound.ui(); this.saveName(); this.showMatchmaker(); };
    $("matchBack").onclick = () => { Sound.ui(); this.matchmakerBack(); };
    $("mmSpellbookBtn").onclick = () => { Sound.ui(); this.showSpellbook("matchmaker"); };
    $("mmKeybindsBtn").onclick = () => { Sound.ui(); this.openMmKeybinds(); };
    $("mmKeybindsBack").onclick = () => { Sound.ui(); this.closeMmOverlay(); };
    $("menuSpellbookBtn").onclick = () => { Sound.ui(); this.showSpellbook("home"); };
    $("learnBtn").onclick = () => { Sound.ui(); this.showLearn(); };
    $("learnBack").onclick = () => { Sound.ui(); this.learnBack(); };
    $("learnSpellbookBtn").onclick = () => { Sound.ui(); this.openLearnSpellbook(); };
    $("learnKeybindsBtn").onclick = () => { Sound.ui(); this.openLearnKeybinds(); };
    $("spellbookBack").onclick = () => { Sound.ui(); this.spellbookBack(); };
    $("mmKeybindsReset").onclick = () => this.resetKeybinds();
    $("soloBack").onclick = () => { Sound.ui(); this.showHome(); };

    $("mmQueueInviteBtn").onclick = () => { Sound.ui(); this.acceptQueueInvite(); };
    $("mmQueueInviteDecline").onclick = () => { Sound.ui(); this.declineQueueInvite(); };

    // keybind remapping (start-screen sub-view)
    $("keybindsBtn").onclick = () => { Sound.ui(); this.showKeybinds("home"); };
    $("keybindsBack").onclick = () => { Sound.ui(); this.keybindsBack(); };
    $("keybindsReset").onclick = () => this.resetKeybinds();

    // match history (recent finished matches on this server)
    $("historyBtn").onclick = () => { Sound.ui(); this.showHistory(); };
    $("achievementsBtn").onclick = () => { Sound.ui(); this.openAchievementsDialog(); };
    $("patchNotesMinimize").onclick = () => { Sound.ui(); this.togglePatchNotesMinimized(); };
    $("patchNotesExpand").onclick = () => {
      Sound.ui();
      if (this.isPatchNotesMinimized()) this.setPatchNotesMinimized(false);
    };
    $("profileChipBtn").onclick = () => this.onProfileChipClick();
    $("profileMinimize").onclick = () => this.closeProfile();
    const profileSignOutBtn = $("profileSignOutBtn");
    if (profileSignOutBtn) profileSignOutBtn.onclick = () => { void this.signOut(); };
    $("preAlphaMinimize").onclick = () => { Sound.ui(); this.togglePreAlphaMinimized(); };
    $("preAlphaExpand").onclick = () => {
      Sound.ui();
      if (this.isPreAlphaMinimized()) this.setPreAlphaMinimized(false);
    };
    this.setPreAlphaMinimized(this.isPreAlphaMinimized()); // restore persisted choice
    this.setupPreAlphaSignEasterEgg();
    const alphaScheduledLearn = $("alphaScheduledLearn");
    if (alphaScheduledLearn) alphaScheduledLearn.onclick = () => this.openAlphaScheduledLearn();
    const alphaScheduledSpellbook = $("alphaScheduledSpellbook");
    if (alphaScheduledSpellbook) alphaScheduledSpellbook.onclick = () => this.openAlphaScheduledSpellbook();
    $("historyBack").onclick = () => { Sound.ui(); this.showHome(); };
    $("reportCenterBtn").onclick = () => { Sound.ui(); this.openReportCenter(); };
    $("creditsBtn").onclick = () => { Sound.ui(); this.showCredits(); };
    $("creditsBack").onclick = () => { Sound.ui(); this.showHome(); };

    // accounts: welcome gate, guest sign-in link, sign-in panel
    $("playAsGuestBtn").onclick = () => this.choosePlayAsGuest();
    $("welcomeSignInBtn").onclick = () => this.chooseSignInFromWelcome();
    $("guestSignInLink").onclick = () => { Sound.ui(); this.showSignIn(); };
    $("signInGoogleBtn").onclick = () => { Sound.ui(); this.storeSignInNickname(); window.location.href = "/auth/google/login"; };
    $("signInDiscordBtn").onclick = () => { Sound.ui(); this.storeSignInNickname(); window.location.href = "/auth/discord/login"; };
    $("signInBack").onclick = () => { Sound.ui(); this.showHome(); };
    $("signOutBtn").onclick = () => { void this.signOut(); };
    // Guests pick a nickname on the home screen; signed-in accounts use accountBox.
    const nameField = $("nameInput");
    if (nameField) {
      nameField.addEventListener("change", () => {
        if (!this.account) this.saveName();
      });
      nameField.addEventListener("keydown", (e) => { if (e.key === "Enter") nameField.blur(); });
    }
    this.loadAccount();

    const wireActiveGame = (reconnectId, leaveId) => {
      const reconnectBtn = $(reconnectId);
      const leaveBtn = $(leaveId);
      if (reconnectBtn) reconnectBtn.onclick = () => { Sound.ui(); this.reconnectActive(); };
      if (leaveBtn) leaveBtn.onclick = () => { Sound.ui(); void this.abandonActiveGame(); };
    };
    wireActiveGame("activeGameReconnect", "activeGameLeave");
    wireActiveGame("activeGameReconnectFind", "activeGameLeaveFind");

    const createPrefs = loadCreatePrefs();
    this.lobbyBotSkill = createPrefs.botSkill;
    const publicToggle = $("publicToggle");
    if (publicToggle) {
      publicToggle.checked = createPrefs.public;
      publicToggle.addEventListener("change", () => this.persistCreatePrefs());
    }
    this.applyStoredMmPrefs();
    this.setupMatchmakerUI($);
    $("practiceBtn").onclick = () => { Sound.resume(); this.saveName(); this.startPractice(); };
    $("createBtn").onclick = () => { Sound.resume(); this.saveName(); this.goOnline("create"); };
    $("joinBtn").onclick = () => {
      Sound.resume(); this.saveName();
      const code = ($("joinCode").value || "").trim().toUpperCase();
      if (code.length < 3) { this.showFindError("Enter a room code."); return; }
      this.goOnline("join", code);
    };
    $("joinCode").addEventListener("keydown", (e) => { if (e.key === "Enter") $("joinBtn").click(); });

    $("botsPlus").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "bots", n: this.lobby.bots + 1 });
        this.persistCreatePrefs();
      }
    };
    $("botsMinus").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "bots", n: this.lobby.bots - 1 });
        this.persistCreatePrefs();
      }
    };
    $("roundsPlus").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "rounds", n: (this.lobby.rounds || CFG.roundsPerMatch) + 1 });
        this.persistCreatePrefs();
      }
    };
    $("roundsMinus").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "rounds", n: (this.lobby.rounds || CFG.roundsPerMatch) - 1 });
        this.persistCreatePrefs();
      }
    };
    const startGoldInput = $("startGoldInput");
    if (startGoldInput) {
      const commitStartGold = () => {
        if (!this.isHost || !this.net) return;
        const n = clamp(Math.round(Number(startGoldInput.value) || 0), CFG.minStartGold, CFG.maxStartGold);
        startGoldInput.value = n;
        this.matchStartGold = n;
        this.net.send({ t: "startgold", n });
        this.persistCreatePrefs();
      };
      startGoldInput.onchange = commitStartGold;
      startGoldInput.addEventListener("keydown", (e) => { if (e.key === "Enter") startGoldInput.blur(); });
    }
    $("lobbyStart").onclick = () => {
      if (!this.isHost || !this.net) return;
      if (this.isLobbyStartCounting()) {
        this.cancelLobbyStartCountdown();
        return;
      }
      if (!this.lobbyCanStart()) return;
      this.beginLobbyStartCountdown();
    };
    // practice (offline) rounds stepper
    const setMenuRounds = (n) => {
      this.practiceRounds = clamp(Math.round(n), 1, 25);
      $("menuRoundsCount").textContent = this.practiceRounds;
    };
    setMenuRounds(this.practiceRounds);
    $("menuRoundsPlus").onclick = () => setMenuRounds(this.practiceRounds + 1);
    $("menuRoundsMinus").onclick = () => setMenuRounds(this.practiceRounds - 1);

    this.buildBotSkillSeg();

    // practice (offline) start-gold input (hidden on solo setup — server default used)
    const menuStartGold = $("menuStartGold");
    if (menuStartGold) {
      const setMenuStartGold = (n) => {
        this.practiceStartGold = clamp(Math.round(Number(n) || 0), CFG.minStartGold, CFG.maxStartGold);
        menuStartGold.value = this.practiceStartGold;
      };
      setMenuStartGold(this.practiceStartGold);
      menuStartGold.onchange = () => setMenuStartGold(menuStartGold.value);
      menuStartGold.addEventListener("keydown", (e) => { if (e.key === "Enter") menuStartGold.blur(); });
    }

    $("leaveBtn").onclick = () => { Sound.ui(); this.showMenu(this.menuLeaveOpts()); };

    const specPrev = $("specPrev");
    const specNext = $("specNext");
    if (specPrev) specPrev.onclick = () => { Sound.ui(); this.cycleSpectate(-1); };
    if (specNext) specNext.onclick = () => { Sound.ui(); this.cycleSpectate(1); };
    const scoreboardToggle = $("scoreboardToggle");
    if (scoreboardToggle) {
      scoreboardToggle.onclick = () => {
        Sound.ui();
        this.scoreboardOpen = !this.scoreboardOpen;
        this.updateScoreboardToggle();
      };
    }

    this.setupReportCenter($);
    this.setupAchievementsDialog($);

    // Mid-match "Leave": always in shop; otherwise when solo/spectating mid-match or in lobby.
    $("quitBtn").onclick = async () => {
      Sound.ui();
      if (this.matchMode === "sandbox") {
        this.showMenu();
        return;
      }
      if (this.state === "lobby") {
        this.showMenu(this.menuLeaveOpts());
        return;
      }
      const soloLeave = this._fromPractice;
      const ok = await showConfirm({
        title: "Leave match?",
        body: (this.state === "shop" && this.humanCount > 1)
          ? "Leave the match and return to the menu?"
          : soloLeave
            ? "You're the only human in this match. Leaving ends it and returns you to Practice vs Bots."
            : "You're the only human in this match. Leaving ends it and returns you to Custom game.",
        okText: "Leave",
        cancelText: "Keep playing",
      });
      if (ok) this.showMenu(this.menuLeaveOpts());
    };

    $("copyCodeBtn").onclick = async (e) => {
      const code = $("lobbyCode").textContent.trim();
      if (!code || code === "----") return;
      Sound.ui();
      await copyInviteLink(code, e.currentTarget);
    };

    $("sandboxCopyLinkBtn").onclick = async (e) => {
      const code = (this.creds?.code || this.lobby?.code || $("lobbyCode").textContent || "").trim();
      if (!code || code === "----") return;
      Sound.ui();
      await copyInviteLink(code, e.currentTarget);
    };

    const onReadyClick = () => {
      if (this.matchMode === "sandbox" && this.sandboxShopOpen) {
        this.closeSandboxShop();
        return;
      }
      this.shopReadied = !this.shopReadied;          // toggle ready / un-ready
      if (this.net) this.net.send({ t: "ready", on: this.shopReadied });
      this.updateReadyButton();
    };
    $("readyBtn").onclick = onReadyClick;
    $("revealReadyBtn").onclick = onReadyClick;
    const bossIntroReadyBtn = $("bossIntroReadyBtn");
    if (bossIntroReadyBtn) {
      bossIntroReadyBtn.onclick = () => {
        if (this.bossIntroPreview) {
          this.closeBossIntroPreview();
          Sound.ui();
          return;
        }
        this.bossIntroReadied = !this.bossIntroReadied;
        if (this.net) this.net.send({ t: "bossready", on: this.bossIntroReadied });
        this.updateBossIntroReadyButton();
        Sound.ui();
      };
    }

    $("modeNormal").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "mode", mode: "normal" });
        this.persistCreatePrefs({ mode: "normal" });
        Sound.ui();
      }
    };
    $("modeAllRandom").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "mode", mode: "allrandom" });
        this.persistCreatePrefs({ mode: "allrandom" });
        Sound.ui();
      }
    };
    $("modeSkillDraft").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "mode", mode: "skilldraft" });
        this.persistCreatePrefs({ mode: "skilldraft" });
        Sound.ui();
      }
    };
    $("modePvE").onclick = () => {
      if (this.isHost && this.net) {
        this.net.send({ t: "mode", mode: "pve" });
        this.persistCreatePrefs({ mode: "pve", bots: 0 });
        this.lobbyMode = "pve";
        if (this.lobby) this.lobby.bots = 0;
        this.updateModeUI();
        const canStart = this.lobbyCanStart();
        this.syncLobbyStartButton(canStart);
        this.updateLobbyWaitText(canStart, this.spectating);
        Sound.ui();
      }
    };
    $("rematchBtn").onclick = () => { Sound.ui(); this.showMenu(this.matchoverLeaveOpts()); };
    $("onlineRematchBtn").onclick = () => { if (this.isHost && this.net) this.net.send({ t: "rematch" }); };
  }

Game.prototype.unlockPreAlphaEasterEggAchievement = async function () {
    if (!this.account) return;
    try {
      const res = await fetch("/users/me/achievements/unlock", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: "finding_obi_wan" }),
      });
      if (!res.ok) return;
      if (res.status === 204) return;
      const data = await res.json();
      if (data?.name) this.showAchievementToast(data);
    } catch (e) { /* offline or signed out */ }
  }

Game.prototype.setupPreAlphaSignEasterEgg = function () {
    const slot = document.getElementById("preAlphaWorkSign");
    const plate = document.getElementById("preAlphaWorkSignPlate");
    if (!slot || !plate || plate.dataset.easterEggWired === "1") return;
    plate.dataset.easterEggWired = "1";

    const MAX = 54;
    const SNAP = 24;
    let dragY = 0;
    let dragging = false;
    let startPointerY = 0;
    let startDragY = 0;
    let playedRevealSound = false;
    let reportedAchievement = false;

    const apply = () => {
      plate.style.transform = `rotate(-14deg) translateY(${dragY}px)`;
      slot.classList.toggle("is-revealed", dragY > 6);
    };

    const reset = (silent) => {
      dragY = 0;
      dragging = false;
      plate.classList.remove("is-dragging");
      apply();
    };

    this.resetPreAlphaSignEasterEgg = () => reset(true);

    plate.addEventListener("pointerdown", (e) => {
      if (e.button !== 0) return;
      dragging = true;
      playedRevealSound = false;
      startPointerY = e.clientY;
      startDragY = dragY;
      plate.classList.add("is-dragging");
      plate.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    plate.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      dragY = clamp(startDragY + (e.clientY - startPointerY), 0, MAX);
      apply();
      if (!playedRevealSound && dragY >= SNAP) {
        playedRevealSound = true;
        Sound.resume();
        Sound.playHelloThereEasterEgg();
        if (!reportedAchievement) {
          reportedAchievement = true;
          void this.unlockPreAlphaEasterEggAchievement();
        }
      }
    });

    const endDrag = (e) => {
      if (!dragging) return;
      try { plate.releasePointerCapture(e.pointerId); } catch (_) { /* ignore */ }
      reset(true);
    };

    plate.addEventListener("pointerup", endDrag);
    plate.addEventListener("pointercancel", endDrag);
  }

Game.prototype.persistCreatePrefs = function (patch) {
    const cur = loadCreatePrefs();
    const pubEl = document.getElementById("publicToggle");
    saveCreatePrefs({
      public: pubEl ? pubEl.checked : cur.public,
      bots: this.lobby?.bots ?? cur.bots,
      botSkill: this.lobbyBotSkill ?? cur.botSkill,
      rounds: this.lobby?.rounds ?? this.matchRounds ?? cur.rounds,
      startGold: this.matchStartGold ?? cur.startGold,
      mode: this.lobbyMode || cur.mode,
      ...patch,
    });
  }

Game.prototype.persistMmPrefs = function () {
    saveMmPrefs({
      category: this.mmCategory,
      format: this.mmFormat,
      playerSizes: this.mmPlayerSizesList(),
      pvePlayerSizes: this.mmPvePlayerSizesList(),
      teamSizes: [...this.mmTeamSizes].sort((a, b) => a - b),
      teamCounts: [...this.mmTeamCounts].sort((a, b) => a - b),
      modes: this.mmModesList(),
    });
  }

Game.prototype.applyStoredMmPrefs = function () {
    const p = loadMmPrefs();
    this.mmCategory = p.category;
    this.mmFormat = p.format;
    this.mmPlayerSizes = new Set(p.playerSizes);
    this.mmPvePlayerSizes = new Set(p.pvePlayerSizes);
    this.mmTeamSizes = new Set(p.teamSizes);
    this.mmTeamCounts = new Set(p.teamCounts);
    this.mmModes = new Set(p.modes);
  }

Game.prototype.saveName = function () {
    const v = (document.getElementById("nameInput").value || "").trim();
    try { localStorage.setItem("warlock_name", v); } catch (e) {}
  }

Game.prototype.syncLobbyInviteURL = function (code) {
    const url = lobbyInviteURL(code);
    if (location.pathname + location.search !== new URL(url).pathname) {
      history.replaceState(null, "", url);
    }
  }

Game.prototype.lobbyCanStart = function () {
    if (!this.lobby) return false;
    const msg = this.lobby;
    const humanPlayers = (msg.members || []).filter(m => !m.bot && !m.sp).length;
    const fighters = this.lobbyMode === "pve" || this.lobbyMode === "sandbox"
      ? humanPlayers
      : humanPlayers + (msg.bots || 0);
    return fighters >= (this.lobbyMode === "pve" || this.lobbyMode === "sandbox" ? 1 : 2);
  }

Game.prototype.isLobbyStartCounting = function () {
    return this._lobbyStartDeadline > performance.now();
  }

Game.prototype.lobbyStartCountdownLeft = function () {
    if (!this._lobbyStartDeadline) return 0;
    return Math.max(0, Math.ceil((this._lobbyStartDeadline - performance.now()) / 1000));
  }

Game.prototype.updateLobbyWaitText = function (canStart, asSpec) {
    const wait = document.getElementById("lobbyWait");
    if (!wait) return;
    if (this.isHost && this.isLobbyStartCounting()) {
      const n = this.lobbyStartCountdownLeft();
      wait.textContent = n > 0 ? `Starting in ${n}… click the button to cancel` : "Starting…";
      return;
    }
    if (asSpec && this.isHost) {
      wait.textContent = canStart
        ? "Spectating — start when ready, or join as a player on your row."
        : (this.lobbyMode === "pve"
          ? "Spectating — need at least one player to start."
          : this.lobbyMode === "sandbox"
            ? "Spectating — need at least one player to start."
            : "Spectating — add a bot or another player, then start when ready.");
    } else if (asSpec) {
      wait.textContent = "You are spectating — the match will start when the host is ready.";
    } else {
      wait.textContent = this.isHost
        ? (canStart
          ? (this.lobbyMode === "pve"
            ? "Invite friends or start solo."
            : this.lobbyMode === "sandbox"
              ? "Share the code — friends can join before you start, or start solo."
              : "Friends can join with the code above.")
          : (this.lobbyMode === "pve" || this.lobbyMode === "sandbox"
            ? "Need at least one player."
            : "Need at least one other player or bot before starting."))
        : "Waiting for the host to start…";
    }
  }

Game.prototype.syncLobbyStartButton = function (canStart) {
    const startBtn = document.getElementById("lobbyStart");
    if (!startBtn) return;
    startBtn.style.display = this.isHost ? "inline-block" : "none";
    if (this.isHost && this.isLobbyStartCounting()) {
      const n = this.lobbyStartCountdownLeft();
      startBtn.disabled = false;
      startBtn.textContent = n > 0 ? String(n) : "…";
      startBtn.title = "Click to cancel";
      startBtn.classList.add("lobby-start-countdown");
      return;
    }
    startBtn.classList.remove("lobby-start-countdown", "lobby-start-armed", "lobby-start-tick");
    startBtn.title = "";
    startBtn.textContent = "START MATCH";
    startBtn.disabled = this.isHost && !canStart;
  }

Game.prototype.animateLobbyStartButton = function (kind) {
    const startBtn = document.getElementById("lobbyStart");
    if (!startBtn || !startBtn.classList.contains("lobby-start-countdown")) return;
    const cls = kind === "armed" ? "lobby-start-armed" : "lobby-start-tick";
    const animName = kind === "armed" ? "lobbyStartArmed" : "lobbyStartTick";
    startBtn.classList.remove("lobby-start-armed", "lobby-start-tick");
    void startBtn.offsetWidth;
    startBtn.classList.add(cls);
    const done = (e) => {
      if (e && (e.target !== startBtn || e.animationName !== animName)) return;
      startBtn.classList.remove(cls);
      startBtn.removeEventListener("animationend", done);
    };
    startBtn.addEventListener("animationend", done);
  }

Game.prototype.beginLobbyStartCountdown = function () {
    if (!this.isHost || !this.net || this.state !== "lobby" || !this.lobbyCanStart()) return;
    Sound.ui();
    const humanPlayers = (this.lobby.members || []).filter(m => !m.bot && !m.sp).length;
    if (this.lobbyMode === "pve" && humanPlayers === 1) {
      this.net.send({ t: "start" });
      return;
    }
    this._lobbyStartDeadline = performance.now() + 3000;
    this._lobbyStartCountN = 0;
    const canStart = this.lobbyCanStart();
    this.syncLobbyStartButton(canStart);
    this.updateLobbyWaitText(canStart, this.spectating);
    this.animateLobbyStartButton("armed");
    const n = this.lobbyStartCountdownLeft();
    if (n > 0) {
      this._lobbyStartCountN = n;
      Sound.countdown(n);
    }
  }

Game.prototype.cancelLobbyStartCountdown = function (silent) {
    if (!this._lobbyStartDeadline) return;
    if (!silent) Sound.ui();
    this._lobbyStartDeadline = 0;
    this._lobbyStartCountN = 0;
    const canStart = this.lobbyCanStart();
    this.syncLobbyStartButton(canStart);
    this.updateLobbyWaitText(canStart, this.spectating);
  }

Game.prototype.tickLobbyStartCountdown = function () {
    if (!this._lobbyStartDeadline || this.state !== "lobby" || !this.isHost) return;
    if (!this.isLobbyStartCounting()) {
      this._lobbyStartDeadline = 0;
      this._lobbyStartCountN = 0;
      if (this.net && this.lobbyCanStart()) this.net.send({ t: "start" });
      return;
    }
    if (!this.lobbyCanStart()) {
      this.cancelLobbyStartCountdown();
      return;
    }
    const n = this.lobbyStartCountdownLeft();
    if (n !== this._lobbyStartCountN) {
      this._lobbyStartCountN = n;
      if (n > 0) Sound.countdown(n);
      this.animateLobbyStartButton("tick");
    }
    this.syncLobbyStartButton(true);
    this.updateLobbyWaitText(true, this.spectating);
  }

Game.prototype.clearLobbyInviteURL = function () {
    if (location.pathname.startsWith("/lobby")) history.replaceState(null, "", "/");
  }

Game.prototype.joinFromInvite = function (code) {
    this._joiningInvite = true;
    this.saveName();
    this.hideAllPanels();
    const el = document.getElementById("reconnecting");
    if (el) { el.textContent = "Joining lobby…"; el.classList.remove("hidden"); }
    this.syncLobbyInviteURL(code);
    this.goOnline("join", code);
  }

Game.prototype.showToast = function (msg, ms = 4200) {
    const el = document.getElementById("toast");
    if (!el || !msg) return;
    clearTimeout(this._toastTO);
    clearTimeout(this._toastExitTO);
    el.textContent = msg;
    el.classList.remove("show");
    void el.offsetWidth;
    el.classList.add("show");
    this._toastTO = setTimeout(() => {
      el.classList.remove("show");
      this._toastExitTO = setTimeout(() => { el.textContent = ""; }, 340);
    }, ms);
  }

const STACK_TOAST_MAX = 3;
const STACK_TOAST_MS = 10000;

Game.prototype.showStackToast = function (msg, ms = STACK_TOAST_MS) {
    const stack = document.getElementById("toastStack");
    if (!stack || !msg) return;
    while (stack.children.length >= STACK_TOAST_MAX) {
      stack.firstElementChild?.remove();
    }
    const el = document.createElement("div");
    el.className = "stack-toast";
    el.setAttribute("role", "status");
    el.textContent = msg;
    stack.appendChild(el);
    requestAnimationFrame(() => el.classList.add("show"));
    let hideTO = null;
    const dismiss = () => {
      if (hideTO) clearTimeout(hideTO);
      hideTO = null;
      el.classList.remove("show");
      setTimeout(() => el.remove(), 320);
    };
    el.addEventListener("click", dismiss);
    hideTO = setTimeout(dismiss, ms);
  }

Game.prototype.isAtMenu = function () {
    if (this.spectating) return false;
    switch (this.state) {
      case "playing":
      case "countdown":
      case "roundover":
      case "shop":
      case "matchover":
      case "bossintro":
        return false;
      default:
        return true;
    }
  }

Game.prototype.isInArena = function () {
    if (this.spectating) return true;
    switch (this.state) {
      case "playing":
      case "countdown":
      case "roundover":
      case "bossintro":
        return true;
      default:
        return false;
    }
  }

Game.prototype.showAchievementToast = function (msg) {
    if (!msg?.name) return;
    const stack = document.getElementById("toastStack");
    if (!stack) return;
    while (stack.children.length >= STACK_TOAST_MAX) {
      stack.firstElementChild?.remove();
    }
    const el = document.createElement("div");
    el.className = "stack-toast achievement-toast";
    el.setAttribute("role", "status");
    const desc = msg.desc ? `<div class="achievement-toast-desc">${escapeHtml(msg.desc)}</div>` : "";
    el.innerHTML = `<div class="achievement-toast-label">Achievement unlocked</div><div class="achievement-toast-name">${escapeHtml(msg.name)}</div>${desc}`;
    stack.appendChild(el);
    this.layoutToastStack();
    requestAnimationFrame(() => {
      el.classList.add("show");
      this.layoutToastStack();
    });
    let hideTO = null;
    const dismiss = () => {
      if (hideTO) clearTimeout(hideTO);
      hideTO = null;
      el.classList.remove("show");
      setTimeout(() => {
        el.remove();
        this.layoutToastStack();
      }, 320);
    };
    el.addEventListener("click", dismiss);
    hideTO = setTimeout(dismiss, STACK_TOAST_MS);
  }

Game.prototype.showMenuError = function (msg) { if (msg) this.showToast(msg); }

Game.prototype.showFindError = function (msg) { document.getElementById("findError").textContent = msg || ""; }

Game.prototype.mmPvePlayerSizesList = function () {
    return [...this.mmPvePlayerSizes].sort((a, b) => a - b);
  }

Game.prototype.mmPvePlayerSizesAny = function () {
    return mmPveSizesIsAny(this.mmPvePlayerSizes);
  }

Game.prototype.setMmPvePlayerAny = function () {
    this.mmPvePlayerSizes = new Set(MM_PVE_ALL_SIZES);
  }

Game.prototype.toggleMmPvePlayerSize = function (n) {
    if (n < 2 || n > 4) return;
    if (this.mmPvePlayerSizesAny()) {
      this.mmPvePlayerSizes = new Set([n]);
    } else if (this.mmPvePlayerSizes.has(n)) {
      this.mmPvePlayerSizes.delete(n);
      if (this.mmPvePlayerSizes.size === 0) this.setMmPvePlayerAny();
    } else {
      this.mmPvePlayerSizes.add(n);
    }
    Sound.ui();
    this.syncMmPvePlayerCountUI();
    this.persistMmPrefs();
  }

Game.prototype.syncMmPvePlayerCountUI = function () {
    const seg = document.getElementById("mmPvePlayerCount");
    if (!seg) return;
    const any = this.mmPvePlayerSizesAny();
    seg.querySelector("[data-mm-any]")?.classList.toggle("active", any);
    [...seg.children].forEach((b) => {
      if (b.dataset.mmAny != null) return;
      const n = parseInt(b.textContent, 10);
      if (!Number.isFinite(n)) return;
      b.classList.toggle("active", this.mmPvePlayerSizes.has(n));
    });
  }

Game.prototype.mmPlayerSizesList = function () {
    return [...this.mmPlayerSizes].sort((a, b) => a - b);
  }

Game.prototype.mmPlayerSizesAny = function () {
    return mmFfaSizesIsAny(this.mmPlayerSizes);
  }

Game.prototype.setMmPlayerAny = function () {
    this.mmPlayerSizes = new Set(MM_FFA_ALL_SIZES);
  }

Game.prototype.setMmQuickMatchSizes = function () {
    this.mmPlayerSizes = new Set(MM_QUICK_MATCH_SIZES);
  }

Game.prototype.mmPlayerSizesLabel = function () {
    if (this.mmPlayerSizesAny()) return "Any";
    const s = this.mmPlayerSizesList();
    if (!s.length) return "";
    if (s.length === 1) return String(s[0]);
    return s.join(", ");
  }

Game.prototype.mmModesList = function () {
    return this.mmModes.has("skilldraft") ? ["skilldraft"] : [];
  }

Game.prototype.mmModesLabel = function () {
    const m = this.mmModesList();
    if (!m.length) return "";
    return m.map(id => modeLabel(id)).join(" + ");
  }

Game.prototype.toggleMmMode = function (mode) {
    if (mode !== "skilldraft") return;
    if (!this.mmModes.has("skilldraft")) {
      this.mmModes = new Set(["skilldraft"]);
      Sound.ui();
      this.syncMmModeUI();
      this.persistMmPrefs();
    }
  }

Game.prototype.syncMmModeUI = function () {
    const $ = (id) => document.getElementById(id);
    $("mmModeSkillDraft")?.classList.toggle("active", this.mmModes.has("skilldraft"));
    const desc = $("mmModeDesc");
    if (!desc) return;
    if (this.mmModes.has("skilldraft")) {
      desc.textContent = "Between rounds, build your arsenal by choosing from random void offers.";
    } else {
      desc.textContent = "";
    }
  }

Game.prototype.toggleMmPlayerSize = function (n) {
    if (n < 2 || n > 8) return;
    if (this.mmPlayerSizesAny()) {
      this.mmPlayerSizes = new Set([n]);
    } else if (this.mmPlayerSizes.has(n)) {
      this.mmPlayerSizes.delete(n);
      if (this.mmPlayerSizes.size === 0) this.setMmPlayerAny();
    } else {
      this.mmPlayerSizes.add(n);
    }
    Sound.ui();
    this.syncMmPlayerCountUI();
    this.persistMmPrefs();
  }

Game.prototype.syncMmPlayerCountUI = function () {
    const seg = document.getElementById("mmPlayerCount");
    if (!seg) return;
    const any = this.mmPlayerSizesAny();
    seg.querySelector("[data-mm-any]")?.classList.toggle("active", any);
    [...seg.children].forEach((b) => {
      if (b.dataset.mmAny != null) return;
      const n = parseInt(b.textContent, 10);
      if (!Number.isFinite(n)) return;
      b.classList.toggle("active", this.mmPlayerSizes.has(n));
    });
  }

Game.prototype.setupMatchmakerUI = function ($) {
    const seg = $("mmPlayerCount");
    if (seg) {
      seg.innerHTML = "";
      const anyBtn = document.createElement("button");
      anyBtn.type = "button";
      anyBtn.textContent = "Any";
      anyBtn.dataset.mmAny = "1";
      anyBtn.onclick = () => {
        if (this._inMatchQueue) return;
        if (this.mmPlayerSizesAny()) return;
        this.setMmPlayerAny();
        Sound.ui();
        this.syncMmPlayerCountUI();
        this.persistMmPrefs();
      };
      seg.appendChild(anyBtn);
      for (let n = 2; n <= 8; n++) {
        const b = document.createElement("button");
        b.type = "button";
        b.textContent = n;
        b.onclick = () => {
          if (this._inMatchQueue) return;
          this.toggleMmPlayerSize(n);
        };
        seg.appendChild(b);
      }
      this.syncMmPlayerCountUI();
    }
    this._renderMmTeamSize = () => this.renderMmTeamSeg("size");
    this._renderMmTeamCount = () => this.renderMmTeamSeg("count");

    const pveSeg = $("mmPvePlayerCount");
    if (pveSeg) {
      pveSeg.innerHTML = "";
      const anyBtn = document.createElement("button");
      anyBtn.type = "button";
      anyBtn.textContent = "Any";
      anyBtn.dataset.mmAny = "1";
      anyBtn.onclick = () => {
        if (this._inMatchQueue) return;
        if (this.mmPvePlayerSizesAny()) return;
        this.setMmPvePlayerAny();
        Sound.ui();
        this.syncMmPvePlayerCountUI();
        this.persistMmPrefs();
      };
      pveSeg.appendChild(anyBtn);
      for (const n of MM_PVE_ALL_SIZES) {
        const b = document.createElement("button");
        b.type = "button";
        b.textContent = n;
        b.onclick = () => {
          if (this._inMatchQueue) return;
          this.toggleMmPvePlayerSize(n);
        };
        pveSeg.appendChild(b);
      }
      this.syncMmPvePlayerCountUI();
    }

    const syncMmMode = () => this.syncMmModeUI();
    syncMmMode();
    this.syncMmFormatUI();
    $("mmModeSkillDraft").onclick = () => {
      if (this._inMatchQueue) return;
      this.toggleMmMode("skilldraft");
    };
    $("mmFormatFfa").onclick = () => {
      if (this._inMatchQueue) return;
      this.mmFormat = "ffa"; this.syncMmFormatUI(); this.persistMmPrefs(); Sound.ui();
    };
    $("mmFormatTeams").onclick = () => {
      if (this._inMatchQueue) return;
      this.mmFormat = "teams"; this.syncMmFormatUI(); this.persistMmPrefs(); Sound.ui();
    };
    $("mmCategoryPvp").onclick = () => {
      if (this._inMatchQueue || this.mmCategory === "pvp") return;
      this.mmCategory = "pvp";
      this.syncMmFormatUI();
      this.persistMmPrefs();
      Sound.ui();
    };
    $("mmCategoryPve").onclick = () => {
      if (this._inMatchQueue || this.mmCategory === "pve") return;
      this.mmCategory = "pve";
      this.syncMmFormatUI();
      this.persistMmPrefs();
      Sound.ui();
    };
    $("mmFindBtn").onclick = () => {
      if (this.mmFindButtonsBlocked()) return;
      Sound.resume(); this.saveName(); this.startMatchQueue();
    };
    $("mmCancelBtn").onclick = () => { Sound.ui(); this.leaveMatchQueue(); };
    $("mmQueueFillCancel").onclick = () => { Sound.ui(); this.leaveMatchQueue(); };
    $("mmReadyBtn").onclick = () => { Sound.ui(); this.clickMatchReady(); };
    $("mmLeaveBtn").onclick = () => { Sound.ui(); this.clickMatchLeave(); };
  }

Game.prototype.showMmError = function (msg) { const el = document.getElementById("mmError"); if (el) el.textContent = msg || ""; }

Game.prototype.beginMmQueueCooldown = function (secs) {
    const s = Math.max(1, Math.round(secs || 0));
    const deadline = performance.now() + s * 1000;
    if (this._mmQueueCooldownUntil && deadline <= this._mmQueueCooldownUntil) return;
    this._mmQueueCooldownUntil = deadline;
    this.updateMmQueueCooldownUI();
  }

Game.prototype.mmQueueCooldownLeft = function () {
    if (!this._mmQueueCooldownUntil) return 0;
    return Math.max(0, Math.ceil((this._mmQueueCooldownUntil - performance.now()) / 1000));
  }

Game.prototype.isMmQueueCooldown = function () {
    return this.mmQueueCooldownLeft() > 0;
  }

Game.prototype.mmFindButtonsBlocked = function () {
    return this.isMmQueueCooldown() || this._inMatchQueue || !this.isAlphaPlayOpen();
  }

Game.prototype.startQuickMatch = function () {
    if (this.mmFindButtonsBlocked()) {
      if (this.isMmQueueCooldown()) {
        const left = this.mmQueueCooldownLeft();
        if (left > 0) {
          this.showToast(`Wait ${this.formatMmReadyCountdown(this._mmQueueCooldownUntil)} before queuing again.`);
        }
      }
      this.updateMmQueueCooldownUI();
      return;
    }
    Sound.resume();
    this.saveName();
    this.mmCategory = "pvp";
    this.mmFormat = "ffa";
    this.setMmQuickMatchSizes();
    this.mmModes = new Set(["skilldraft"]);
    this.persistMmPrefs();
    this.showMatchmaker();
    this.syncMmFormatUI();
    this.syncMmPlayerCountUI();
    this.syncMmModeUI();
    this.startMatchQueue();
  }

Game.prototype.updateMmQueueCooldownUI = function () {
    const left = this.mmQueueCooldownLeft();
    const findBtn = document.getElementById("mmFindBtn");
    const quickBtn = document.getElementById("homeQuickMatchBtn");
    const blocked = this.mmFindButtonsBlocked();
    if (findBtn) findBtn.disabled = blocked;
    if (quickBtn) quickBtn.disabled = blocked;
    const err = document.getElementById("mmError");
    if (left > 0) {
      this.showMmError(`Wait ${this.formatMmReadyCountdown(this._mmQueueCooldownUntil)} before queuing again.`);
    } else if (err?.textContent?.includes("before queuing again")) {
      this.showMmError("");
    }
  }

Game.prototype.mmOverlayOpen = function () {
    return !document.getElementById("mmKeybinds")?.classList.contains("hidden");
  }

Game.prototype.openMmKeybinds = function () {
    if (this._readyCheck) return;
    this.renderKeybinds();
    this.hide("mmMain");
    this.show("mmKeybinds");
  }

Game.prototype.closeMmOverlay = function () {
    this.cancelRebind();
    this.hide("mmKeybinds");
    this.show("mmMain");
  }

Game.prototype.showSpellbook = function (returnTo = "home") {
    if (this._readyCheck) return;
    this._spellbookReturn = returnTo;
    this.homeView = "spellbook";
    this.stopRoomPoll();
    this.stopLearnPreviews?.();
    this.closeMmOverlay();
    this.closeReportCenter();
    this.hide("menu"); this.hide("findGame"); this.hide("matchmaker"); this.hide("soloSetup"); this.hide("signInPanel");
    this.hide("keybinds"); this.hide("historyPanel"); this.hide("creditsPanel"); this.hide("learnPanel");
    this.syncPatchNotesWidget(false);
    this.syncProfileWidget(false);
    this.show("spellbook");
    const render = () => this.renderSpellbookCatalog("spellbookCatalog");
    render();
    this.ensureCatalog?.().then(render);
  }

Game.prototype.spellbookBack = function () {
    SpellPreview.hide();
    const ret = this._spellbookReturn || "home";
    this.hide("spellbook");
    if (ret === "matchmaker") this.showMatchmaker();
    else if (ret === "learn") this.showLearn();
    else if (ret === "alpha-scheduled") this.showAlphaScheduledSplash();
    else this.showHome();
  }

Game.prototype.spellCostLabel = function (spell) {
    if (!spell) return "";
    const unlock = spellUnlockSp(spell);
    const { upgrades, synergies } = spellPassiveSummary(spell.id);
    if (!upgrades && !synergies) return `${unlock} SP`;
    const parts = [`${unlock} SP`];
    if (upgrades) parts.push(`${upgrades} passive${upgrades !== 1 ? "s" : ""}`);
    if (synergies) parts.push(`${synergies} synergy`);
    return parts.join(" · ");
  }

Game.prototype.buildSpellbookSpellCard = function (id) {
    const s = SPELLS[id];
    const card = document.createElement("div");
    if (!s) return card;
    const st = spellAvail(id);
    const costCls = s.cost === 0 ? "starter" : "";
    card.className = "spell-card shop-spell-card spellbook-spell-card owned" +
      (st === "coming_soon" ? " spell-coming-soon" : st === "disabled" ? " spell-disabled" : "");
    card.setAttribute("data-tip-kind", "spell");
    card.setAttribute("data-tip-id", id);
    card.setAttribute("data-spell-id", id);
    if (SpellPreview.has(id)) {
      card.classList.add("spell-card-previewable");
      card.dataset.spellPreview = id;
    }
    let badge = "";
    if (st === "coming_soon") badge = '<span class="mm-spell-badge soon">Coming soon</span>';
    else if (st === "disabled") badge = '<span class="mm-spell-badge off">Unavailable</span>';
    const meta = this.spellMetaLine(s);
    const stats = [
      `<span class="shop-owned-stat spellbook-cost ${costCls}">${escapeHtml(this.spellCostLabel(s))}</span>`,
      meta ? `<span class="shop-owned-stat">${escapeHtml(meta)}</span>` : "",
      badge,
    ].filter(Boolean).join("");
    card.innerHTML = `
      <div class="spell-icon shop-spell-icon" style="background:${s.color}33;border:1px solid ${s.color}">${spellIconInner(id)}</div>
      <div class="shop-spell-meta">
        <div class="spell-name">${escapeHtml(s.name)}</div>
        ${stats ? `<div class="shop-owned-spell-stats">${stats}</div>` : ""}
      </div>`;
    return card;
  }

Game.prototype.spellMetaLine = function (spell) {
    if (!spell) return "";
    const parts = [];
    if (spell.cooldown) parts.push(`${spell.cooldown}s cooldown`);
    if (spell.type) parts.push(spell.type);
    return parts.join(" · ");
  }

Game.prototype.renderSpellbookCatalog = function (containerId = "spellbookCatalog") {
    const grid = document.getElementById(containerId);
    if (!grid) return;
    grid.className = "shop-categories";
    grid.innerHTML = "";

    for (const cat of SHOP_CATEGORY_ORDER) {
      const ids = SPELLS_IN_CATEGORY(cat);
      if (!ids.length) continue;
      const block = document.createElement("div");
      block.className = "category-block spellbook-slot";
      const head = document.createElement("div");
      head.className = "category-head";
      head.textContent = shopCategoryLabel(cat);
      block.appendChild(head);
      const opts = document.createElement("div");
      opts.className = "category-options spellbook-spells";
      for (const id of ids) {
        if (!SPELLS[id]) continue;
        const ref = document.createElement("div");
        ref.className = "slot-spell-ref";
        const card = this.buildSpellbookSpellCard(id);
        const tree = this.buildSkillTree(id, {}, { sp: 0, pp: 0, sy: 0 }, {}, null, {
          readOnly: true,
          showPassives: true,
          showSynergies: true,
          layout: "owned-row",
        });
        const unit = document.createElement("div");
        unit.className = "spell-skill-unit spell-skill-unit-owned-row owned";
        unit.appendChild(card);
        if (tree) unit.appendChild(tree);
        ref.appendChild(unit);
        opts.appendChild(ref);
      }
      block.appendChild(opts);
      grid.appendChild(block);
    }
    this.wireSynergyPartnerHoverGrid(grid);
    refreshSpellCatalogSearch();
  }

Game.prototype.mmAllowedTeamCountsForSize = function (size) {
    if (size === 4) return [2];
    if (size === 3) return [2, 3];
    return [2, 3, 4];
  }

Game.prototype.mmTeamSizesList = function () {
    return [...this.mmTeamSizes].sort((a, b) => a - b);
  }

Game.prototype.mmTeamCountsList = function () {
    return [...this.mmTeamCounts].sort((a, b) => a - b);
  }

Game.prototype.mmAllowedTeamCountsUnion = function () {
    const out = new Set();
    for (const size of this.mmTeamSizes) {
      for (const c of this.mmAllowedTeamCountsForSize(size)) out.add(c);
    }
    return out;
  }

Game.prototype.mmTeamSizesAny = function () {
    return mmTeamSizesIsAny(this.mmTeamSizes);
  }

Game.prototype.setMmTeamSizesAny = function () {
    this.mmTeamSizes = new Set(MM_TEAM_ALL_SIZES);
  }

Game.prototype.mmTeamCountsAny = function () {
    const allowed = this.mmAllowedTeamCountsUnion();
    if (!allowed.size) return false;
    for (const c of allowed) {
      if (!this.mmTeamCounts.has(c)) return false;
    }
    return true;
  }

Game.prototype.setMmTeamCountsAny = function () {
    this.mmTeamCounts = new Set(this.mmAllowedTeamCountsUnion());
  }

Game.prototype.toggleMmTeamSize = function (size) {
    if (this.mmTeamSizesAny()) {
      this.mmTeamSizes = new Set([size]);
    } else if (this.mmTeamSizes.has(size)) {
      this.mmTeamSizes.delete(size);
      if (this.mmTeamSizes.size === 0) this.setMmTeamSizesAny();
    } else {
      this.mmTeamSizes.add(size);
    }
    Sound.ui();
    this.syncMmTeamsUI();
    this.persistMmPrefs();
  }

Game.prototype.toggleMmTeamCount = function (count) {
    const allowed = this.mmAllowedTeamCountsUnion();
    if (!allowed.has(count)) return;
    if (this.mmTeamCountsAny()) {
      this.mmTeamCounts = new Set([count]);
    } else if (this.mmTeamCounts.has(count)) {
      this.mmTeamCounts.delete(count);
      if (this.mmTeamCounts.size === 0) this.setMmTeamCountsAny();
    } else {
      this.mmTeamCounts.add(count);
    }
    Sound.ui();
    this.syncMmTeamsUI();
    this.persistMmPrefs();
  }

Game.prototype.syncMmTeamSizeUI = function () {
    const el = document.getElementById("mmTeamSize");
    if (!el) return;
    const any = this.mmTeamSizesAny();
    el.querySelector("[data-mm-any]")?.classList.toggle("active", any);
    [...el.querySelectorAll("button[data-mm-team-size]")].forEach((b) => {
      const size = parseInt(b.dataset.mmTeamSize, 10);
      b.classList.toggle("active", this.mmTeamSizes.has(size));
    });
  }

Game.prototype.syncMmTeamCountUI = function () {
    const el = document.getElementById("mmTeamCount");
    if (!el) return;
    const allowed = this.mmAllowedTeamCountsUnion();
    const any = this.mmTeamCountsAny();
    const anyBtn = el.querySelector("[data-mm-any]");
    if (anyBtn) {
      anyBtn.classList.toggle("active", any);
      anyBtn.disabled = allowed.size === 0;
    }
    [...el.querySelectorAll("button[data-mm-team-count]")].forEach((b) => {
      const count = parseInt(b.dataset.mmTeamCount, 10);
      const disabled = !allowed.has(count);
      b.disabled = disabled;
      b.classList.toggle("active", !disabled && this.mmTeamCounts.has(count));
    });
  }

Game.prototype.renderMmTeamSeg = function (kind) {
    const $ = (id) => document.getElementById(id);
    if (kind === "size") {
      const el = $("mmTeamSize");
      if (!el) return;
      if (el.dataset.mmBuilt === "1") {
        this.syncMmTeamSizeUI();
        return;
      }
      el.innerHTML = "";
      const anyBtn = document.createElement("button");
      anyBtn.type = "button";
      anyBtn.textContent = "Any";
      anyBtn.dataset.mmAny = "1";
      anyBtn.onclick = () => {
        if (this._inMatchQueue) return;
        if (this.mmTeamSizesAny()) return;
        this.setMmTeamSizesAny();
        Sound.ui();
        this.syncMmTeamsUI();
        this.persistMmPrefs();
      };
      el.appendChild(anyBtn);
      for (const opt of [{ value: 2, label: "2v2" }, { value: 3, label: "3v3" }, { value: 4, label: "4v4" }]) {
        const b = document.createElement("button");
        b.type = "button";
        b.textContent = opt.label;
        b.dataset.mmTeamSize = String(opt.value);
        b.onclick = () => {
          if (this._inMatchQueue) return;
          this.toggleMmTeamSize(opt.value);
        };
        el.appendChild(b);
      }
      el.dataset.mmBuilt = "1";
      this.syncMmTeamSizeUI();
      return;
    }
    const el = $("mmTeamCount");
    if (!el) return;
    if (el.dataset.mmBuilt === "1") {
      this.syncMmTeamCountUI();
      return;
    }
    el.innerHTML = "";
    const anyBtn = document.createElement("button");
    anyBtn.type = "button";
    anyBtn.textContent = "Any";
    anyBtn.dataset.mmAny = "1";
    anyBtn.onclick = () => {
      if (this._inMatchQueue) return;
      if (this.mmTeamCountsAny()) return;
      this.setMmTeamCountsAny();
      Sound.ui();
      this.syncMmTeamsUI();
      this.persistMmPrefs();
    };
    el.appendChild(anyBtn);
    for (const opt of [{ value: 2, label: "2" }, { value: 3, label: "3" }, { value: 4, label: "4" }]) {
      const b = document.createElement("button");
      b.type = "button";
      b.textContent = opt.label;
      b.dataset.mmTeamCount = String(opt.value);
      b.onclick = () => {
        if (this._inMatchQueue || b.disabled) return;
        this.toggleMmTeamCount(opt.value);
      };
      el.appendChild(b);
    }
    el.dataset.mmBuilt = "1";
    this.syncMmTeamCountUI();
  }

Game.prototype.syncMmTeamsUI = function () {
    const allowed = this.mmAllowedTeamCountsUnion();
    for (const c of [...this.mmTeamCounts]) {
      if (!allowed.has(c)) this.mmTeamCounts.delete(c);
    }
    if (this.mmTeamCounts.size === 0 && allowed.size > 0) {
      this.setMmTeamCountsAny();
    }
    if (this.mmTeamSizes.size === 0) {
      this.setMmTeamSizesAny();
    }
    this._renderMmTeamSize?.();
    this._renderMmTeamCount?.();
  }

Game.prototype.syncMmFormatUI = function () {
    const pvp = this.mmCategory !== "pve";
    const ffa = pvp && this.mmFormat !== "teams";
    const $ = (id) => document.getElementById(id);
    $("mmCategoryPvp")?.classList.toggle("active", pvp);
    $("mmCategoryPve")?.classList.toggle("active", !pvp);
    $("mmPvpCol")?.classList.toggle("is-active", pvp);
    $("mmPveCol")?.classList.toggle("is-active", !pvp);
    $("mmPvpFormat")?.classList.toggle("hidden", !pvp);
    $("mmFormatFfa")?.classList.toggle("active", ffa);
    $("mmFormatTeams")?.classList.toggle("active", pvp && !ffa);
    $("mmFfaPlayers")?.classList.toggle("hidden", !ffa);
    $("mmPvePlayers")?.classList.toggle("hidden", pvp);
    $("mmTeamsSetup")?.classList.toggle("hidden", !pvp || ffa);
    $("mmFixedSettings")?.classList.toggle("hidden", !pvp);
    document.querySelector(".mm-ranked-block")?.classList.toggle("hidden", !pvp);
    if (pvp && !ffa) this.syncMmTeamsUI();
    const findBtn = $("mmFindBtn");
    if (findBtn) {
      findBtn.textContent = "FIND MATCH";
      findBtn.disabled = this.mmFindButtonsBlocked();
      findBtn.classList.remove("mm-find-soon");
    }
    if ($("mmMatchIdle") && !this._inMatchQueue) $("mmMatchIdle").classList.remove("hidden");
  }

Game.prototype.updateMmFixedSettings = function () {
    const el = document.getElementById("mmFixedSettings");
    if (el) {
      el.textContent = `${this.mmRounds} rounds`;
    }
  }

Game.prototype.fetchMatchmakerConfig = async function () {
    try {
      const r = await fetch("/api/matchmaker");
      if (!r.ok) return;
      const cfg = await r.json();
      if (cfg.rounds > 0) this.mmRounds = cfg.rounds;
      if (cfg.startGold != null) this.mmStartGold = cfg.startGold;
      if (cfg.queueCd > 0) this.beginMmQueueCooldown(cfg.queueCd);
      else this.updateMmQueueCooldownUI();
      this.updateMmFixedSettings();
    } catch (e) { /* keep defaults */ }
  }

Game.prototype.mmQueueTipsVisible = function () {
    if (!this._inMatchQueue || this._readyCheck) return false;
    if (!document.getElementById("mmQueueFillBackdrop")?.classList.contains("hidden")) return false;
    const searching = document.getElementById("mmSearching");
    return !searching?.classList.contains("is-match");
  }

Game.prototype.formatMmFillCount = function (found, want, min, gathering) {
    // Below minimum: progress toward the player count needed to start the timer.
    if (gathering && found < min) {
      return `${found} / ${min} players found`;
    }
    // Countdown (or at/above min): progress toward the full lobby size.
    return `${found} / ${want} players found`;
  }

Game.prototype.formatMmFillStartLabel = function (players) {
    const fmt = this._matchmake?.format;
    const n = Math.max(2, players);
    if (n === 2 && (fmt === "ffa" || !fmt)) return "1v1";
    if (n === 2 && fmt === "pve") return "co-op for 2";
    if (n === 2) return "1v1";
    return `a ${n}-player match`;
  }

Game.prototype.formatMmFillStatus = function (found, want, min, gathering) {
    const needForMin = Math.max(0, min - found);
    const needForFull = Math.max(0, want - found);
    if (gathering) {
      if (needForMin > 0) {
        const needWord = needForMin === 1 ? "1 more player" : `${needForMin} more players`;
        if (min === want) {
          return `Need ${needWord} before the match can start.`;
        }
        return `Need ${needWord} before we start looking for a full ${want}-player lobby.`;
      }
      if (needForFull > 0) {
        const needWord = needForFull === 1 ? "1 more player" : `${needForFull} more players`;
        return `Waiting for ${needWord} for a full ${want}-player lobby.`;
      }
      return "Starting soon…";
    }
    if (needForFull <= 0) return "Lobby full — starting soon…";
    const needWord = needForFull === 1 ? "1 more player" : `${needForFull} more players`;
    const fallback = this.formatMmFillStartLabel(found);
    return `Waiting for ${needWord} for a full ${want}-player lobby — otherwise starting ${fallback} when the timer runs out.`;
  }

Game.prototype.hideQueueFillModal = function () {
    document.getElementById("mmQueueFillBackdrop")?.classList.add("hidden");
    this._mmFillDeadline = 0;
    this.syncMmFillTimer(true);
  }

Game.prototype.updateQueueFillModal = function (found, want, min, gathering) {
    const backdrop = document.getElementById("mmQueueFillBackdrop");
    const count = document.getElementById("mmQueueFillCount");
    const status = document.getElementById("mmQueueFillStatus");
    if (!backdrop) return;
    backdrop.classList.remove("hidden");
    if (count) count.textContent = this.formatMmFillCount(found, want, min, gathering);
    if (status) status.textContent = this.formatMmFillStatus(found, want, min, gathering);
    this.syncMmFillTimer(gathering);
  }

Game.prototype.resetMmQueueTip = function () {
    this._mmTipActive = false;
    this._mmTipLast = "";
    clearTimeout(this._mmTipHideTO);
    clearTimeout(this._mmTipNextTO);
    this._mmTipHideTO = null;
    this._mmTipNextTO = null;
    const el = document.getElementById("mmTipToast");
    if (!el) return;
    el.classList.remove("show");
    const text = el.querySelector(".mm-tip-toast-text");
    if (text) text.textContent = "";
  }

Game.prototype.showMmQueueTipToast = function () {
    if (!this.mmQueueTipsVisible()) {
      this.resetMmQueueTip();
      return;
    }
    const el = document.getElementById("mmTipToast");
    if (!el) return;
    const text = el.querySelector(".mm-tip-toast-text");
    if (!text) return;
    this._mmTipLast = pickMmQueueTip(this._mmTipLast);
    text.textContent = this._mmTipLast;
    clearTimeout(this._mmTipHideTO);
    clearTimeout(this._mmTipNextTO);
    el.classList.remove("show");
    void el.offsetWidth;
    el.classList.add("show");
    this._mmTipHideTO = setTimeout(() => {
      el.classList.remove("show");
      this._mmTipNextTO = setTimeout(() => {
        if (this._mmTipActive) this.showMmQueueTipToast();
      }, MM_QUEUE_TIP_MS.gap);
    }, rand(MM_QUEUE_TIP_MS.min, MM_QUEUE_TIP_MS.max));
  }

Game.prototype.loadQueueInviteSnoozeUntil = function () {
    try {
      const raw = localStorage.getItem("wlkQueueInviteSnooze");
      const n = raw ? Number(raw) : 0;
      return Number.isFinite(n) && n > Date.now() ? n : 0;
    } catch (e) {
      return 0;
    }
  }

Game.prototype.saveQueueInviteSnoozeUntil = function (deadline) {
    this._queueInviteSnoozeUntil = deadline;
    try {
      if (deadline > Date.now()) {
        localStorage.setItem("wlkQueueInviteSnooze", String(deadline));
      } else {
        localStorage.removeItem("wlkQueueInviteSnooze");
      }
    } catch (e) { /* ignore */ }
  }

Game.prototype.queueInviteSnoozed = function () {
    if (!this._queueInviteSnoozeUntil) return false;
    if (Date.now() >= this._queueInviteSnoozeUntil) {
      this.saveQueueInviteSnoozeUntil(0);
      return false;
    }
    return true;
  }

Game.prototype.startMmQueueTips = function () {
    if (this._mmTipActive || !this.mmQueueTipsVisible()) return;
    this._mmTipActive = true;
    this._mmTipLast = "";
    this.showMmQueueTipToast();
  }

Game.prototype.shouldStoreQueueInvite = function () {
    return this.isAtMenu() && this.mode === "local" && !this._inMatchQueue && !this._readyCheck && !this.queueInviteSnoozed();
  }

Game.prototype.canShowQueueInvite = function () {
    if (!this.shouldStoreQueueInvite()) return false;
    if (!this.homeAuthReady || this.shouldShowAuthWelcome()) return false;
    if (this.homeView === "signin" || this.panelVisible("signInPanel")) return false;
    return true;
  }

Game.prototype.onQueueInvite = function (msg) {
    if (!this.shouldStoreQueueInvite()) return;
    this._queueInvite = msg;
    this.syncQueueInviteUI();
  }

Game.prototype.syncQueueInviteUI = function () {
    const el = document.getElementById("mmQueueInvite");
    if (!el) return;
    if (!this._queueInvite || !this.canShowQueueInvite()) {
      this.hideQueueInvite();
      return;
    }
    el.classList.remove("hidden");
    requestAnimationFrame(() => el.classList.add("is-visible"));
  }

Game.prototype.hideQueueInvite = function () {
    const el = document.getElementById("mmQueueInvite");
    if (!el) return;
    el.classList.remove("is-visible");
    el.classList.add("hidden");
  }

Game.prototype.dismissQueueInvite = function () {
    this._queueInvite = null;
    this.hideQueueInvite();
  }

Game.prototype.onQueueInviteEnd = function () {
    this.dismissQueueInvite();
  }

Game.prototype.declineQueueInvite = function () {
    this.saveQueueInviteSnoozeUntil(Date.now() + 3 * 60 * 1000);
    this.dismissQueueInvite();
  }

Game.prototype.applyQueueInvitePrefs = function (msg) {
    if (msg.rounds > 0) this.mmRounds = msg.rounds;
    if (msg.startGold != null) this.mmStartGold = msg.startGold;
    const mode = msg.mode || "skilldraft";
    if (msg.format === "pve") {
      this.mmCategory = "pve";
      this.mmPvePlayerSizes = new Set([msg.players || 2]);
      this.mmModes = new Set(["pve"]);
    } else if (msg.format === "teams") {
      this.mmCategory = "pvp";
      this.mmFormat = "teams";
      this.mmTeamSizes = new Set([msg.teamSize || 2]);
      this.mmTeamCounts = new Set([msg.teamCount || 2]);
      this.mmModes = new Set([mode]);
    } else {
      this.mmCategory = "pvp";
      this.mmFormat = "ffa";
      const max = Math.max(2, msg.players || 8);
      const sizes = [];
      for (let n = 2; n <= max; n++) sizes.push(n);
      this.mmPlayerSizes = new Set(sizes);
      this.mmModes = new Set([mode]);
    }
    this.syncMmFormatUI();
    this.updateMmFixedSettings();
  }

Game.prototype.acceptQueueInvite = function () {
    if (!this._queueInvite || this._inMatchQueue) return;
    if (this.rejectIfAlphaClosed()) return;
    if (this.isMmQueueCooldown()) {
      this.updateMmQueueCooldownUI();
      return;
    }
    const inv = this._queueInvite;
    this.dismissQueueInvite();
    this.saveName();
    this.applyQueueInvitePrefs(inv);
    this.showMatchmaker();
    this.startMatchQueue();
  }

Game.prototype.updateMatchQueueUI = function (msg) {
    const status = document.getElementById("mmStatus");
    const searching = document.getElementById("mmSearching");
    const idle = document.getElementById("mmMatchIdle");
    const inQueue = this._inMatchQueue;
    const showSearch = inQueue && !this._readyCheck;
    if (idle) idle.classList.toggle("hidden", inQueue);
    if (searching) {
      searching.classList.toggle("hidden", !showSearch);
      searching.classList.toggle("is-active", showSearch);
    }
    if (!showSearch) {
      this.hideQueueFillModal();
      if (status) status.textContent = "";
      searching?.classList.remove("is-match");
      this.resetMmQueueTip();
      return;
    }
    const want = msg?.players ?? 0;
    const min = msg?.min ?? 0;
    const found = Math.max(1, msg?.matching ?? 1);
    const inMatchFound = min >= 2;
    const gathering = inMatchFound && (msg?.secs ?? 0) <= 0;
    const counting = inMatchFound && (msg?.secs ?? 0) > 0;
    const matched = inMatchFound && found >= want && want >= min;
    if (inMatchFound) {
      if (counting) {
        this._mmFillDeadline = performance.now() + (msg?.secs ?? 0) * 1000;
      } else {
        this._mmFillDeadline = 0;
      }
      this.updateQueueFillModal(found, want, min, gathering);
    } else {
      this._mmFillDeadline = 0;
      this.hideQueueFillModal();
    }
    searching?.classList.toggle("is-match", inMatchFound);
    if (!status) return;
    status.textContent = matched
      ? "Match found — ready check opening…"
      : inMatchFound
      ? ""
      : `Searching… ${this.formatMmQueueElapsed()}`;
    if (inMatchFound || matched) this.resetMmQueueTip();
    else this.startMmQueueTips();
  }

Game.prototype.formatMmQueueElapsed = function () {
    if (!this._mmQueueSince) return "00:00";
    const s = Math.max(0, Math.floor((performance.now() - this._mmQueueSince) / 1000));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return String(m).padStart(2, "0") + ":" + String(r).padStart(2, "0");
  }

Game.prototype.updateMmQueueTimer = function () {
    if (!this._inMatchQueue || this._readyCheck) return;
    const status = document.getElementById("mmStatus");
    if (!status) return;
    const searching = document.getElementById("mmSearching");
    if (searching?.classList.contains("is-match")) return;
    if (!document.getElementById("mmQueueFillBackdrop")?.classList.contains("hidden")) return;
    status.textContent = `Searching… ${this.formatMmQueueElapsed()}`;
  }

Game.prototype.formatMmReadyCountdown = function (deadline) {
    const s = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return String(m).padStart(2, "0") + ":" + String(r).padStart(2, "0");
  }

Game.prototype.syncMmFillTimer = function (hide) {
    const el = document.getElementById("mmQueueFillTimer");
    if (!el) return;
    if (hide || !this._mmFillDeadline) {
      el.classList.add("hidden");
      return;
    }
    el.classList.remove("hidden");
    el.textContent = this.formatMmReadyCountdown(this._mmFillDeadline);
  }

Game.prototype.updateMmFillTimer = function () {
    if (!this._inMatchQueue || this._readyCheck || !this._mmFillDeadline) return;
    const backdrop = document.getElementById("mmQueueFillBackdrop");
    if (!backdrop || backdrop.classList.contains("hidden")) return;
    this.syncMmFillTimer(false);
  }

Game.prototype.syncMmReadyCheckTimer = function (hide) {
    const el = document.getElementById("mmReadyCheckTimer");
    if (!el) return;
    if (hide || !this._mmReadyDeadline) {
      el.classList.add("hidden");
      return;
    }
    el.classList.remove("hidden");
    el.textContent = this.formatMmReadyCountdown(this._mmReadyDeadline);
  }

Game.prototype.updateMmReadyCheckTimer = function () {
    if (!this._readyCheck || !this._mmReadyDeadline) return;
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    if (!backdrop || backdrop.classList.contains("hidden") || backdrop.classList.contains("is-resuming")) return;
    this.syncMmReadyCheckTimer(false);
  }

Game.prototype.showReadyCheck = function () {
    this.dismissQueueInvite();
    this.hideQueueFillModal();
    this._readyCheck = true;
    this._mmReadied = false;
    this._mmReadyDeadline = 0;
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    const readyBtn = document.getElementById("mmReadyBtn");
    if (backdrop) backdrop.classList.remove("hidden");
    if (readyBtn) {
      readyBtn.textContent = "Accept";
      readyBtn.classList.remove("is-readied");
      readyBtn.disabled = false;
    }
    const leaveBtn = document.getElementById("mmLeaveBtn");
    if (leaveBtn) leaveBtn.disabled = false;
    this.updateMatchQueueUI(null);
  }

Game.prototype.hideReadyCheck = function () {
    this._readyCheck = false;
    this._mmReadied = false;
    this._mmReadyDeadline = 0;
    this.syncMmReadyCheckTimer(true);
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    if (backdrop) {
      backdrop.classList.remove("is-resuming");
      backdrop.classList.add("hidden");
    }
    const readyBtn = document.getElementById("mmReadyBtn");
    if (readyBtn) {
      readyBtn.textContent = "Accept";
      readyBtn.classList.remove("is-readied");
      readyBtn.disabled = false;
    }
    const leaveBtn = document.getElementById("mmLeaveBtn");
    if (leaveBtn) leaveBtn.disabled = false;
    if (this._inMatchQueue) this.syncMusic();
    this.updateMatchQueueUI(this._inMatchQueue ? { players: 0, waiting: 1, matching: 1 } : null);
  }

Game.prototype.clearMatchmakerOnMatchStart = function () {
    if (!this._matchmake && !this._readyCheck && !this._inMatchQueue) return;
    this.dismissQueueInvite();
    if (this._matchmake) this._fromMatchmaking = true;
    this._inMatchQueue = false;
    this._matchmake = null;
    this.hideReadyCheck();
    this.hideQueueFillModal();
    this.setMatchQueueSearching(false);
    this.updateQuitButton();
  }

Game.prototype.onReadyCheck = function (msg) {
    if (!this._matchmake && !this._inMatchQueue) return;
    const resuming = msg.phase === "resuming";
    const wasReady = this._readyCheck;
    this.showReadyCheck();
    if (resuming) {
      this.syncMusic();
    } else if (!wasReady) {
      Sound.beginReadyCheckAudio();
      if (this._inMatchQueue) Sound.startMenuMusic();
    }
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    const status = document.getElementById("mmReadyCheckStatus");
    const roster = document.getElementById("mmReadyCheckRoster");
    if (backdrop) backdrop.classList.toggle("is-resuming", resuming);
    if (resuming) {
      this._mmReadyDeadline = 0;
      this.syncMmReadyCheckTimer(true);
    } else if (msg.secs > 0) {
      this._mmReadyDeadline = performance.now() + msg.secs * 1000;
      this.syncMmReadyCheckTimer(false);
    } else {
      this._mmReadyDeadline = 0;
      this.syncMmReadyCheckTimer(true);
    }
    if (status) {
      if (resuming) {
        const s = msg.secs > 0 ? msg.secs : 1;
        status.textContent = `Resuming queue for everyone — ${s}`;
      } else if (msg.botsOnly) {
        status.textContent = "Bots will fill the lobby — accept to start";
      } else {
        status.textContent = `${msg.ready || 0} / ${msg.total || 0} ready — accept to enter the arena`;
      }
    }
    if (roster) {
      roster.innerHTML = "";
      for (const m of msg.members || []) {
        const li = document.createElement("li");
        const you = !m.bot && m.id === this.myId;
        const tag = document.createElement("span");
        if (m.bot) {
          tag.className = "mm-rc-tag bot";
          tag.textContent = "Bot";
        } else if (m.declined) {
          tag.className = "mm-rc-tag declined";
          tag.textContent = "Declined";
        } else if (m.ready) {
          tag.className = "mm-rc-tag" + (you ? " you-ready" : " ready");
          tag.textContent = you ? "You · ready" : "Ready";
        } else {
          tag.className = "mm-rc-tag";
          tag.textContent = you ? "You" : "Waiting";
        }
        li.innerHTML = `<span class="mm-rc-name">${escapeHtml(m.name)}</span>`;
        li.appendChild(tag);
        roster.appendChild(li);
        if (you && m.ready) this._mmReadied = true;
      }
    }
    const readyBtn = document.getElementById("mmReadyBtn");
    const leaveBtn = document.getElementById("mmLeaveBtn");
    if (resuming) {
      if (readyBtn) readyBtn.disabled = true;
      if (leaveBtn) leaveBtn.disabled = true;
    } else if (readyBtn && this._mmReadied) {
      readyBtn.textContent = "✓ Accept";
      readyBtn.classList.add("is-readied");
    }
  }

Game.prototype.onReadyCheckEnd = function (msg) {
    this.hideReadyCheck();
    this._inMatchQueue = false;
    this._matchmake = null;
    if (msg?.cd > 0) this.beginMmQueueCooldown(msg.cd);
    this.setMatchQueueSearching(false);
    this.syncMusic();
    this.showMatchmaker();
  }

Game.prototype.clickMatchReady = function () {
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    if (backdrop?.classList.contains("is-resuming")) return;
    if (!this._readyCheck || this._mmReadied || !this.net) return;
    this.net.send({ t: "matchready" });
    this._mmReadied = true;
    const readyBtn = document.getElementById("mmReadyBtn");
    if (readyBtn) {
      readyBtn.textContent = "✓ Accept";
      readyBtn.classList.add("is-readied");
    }
  }

Game.prototype.clickMatchLeave = function () {
    const backdrop = document.getElementById("mmReadyCheckBackdrop");
    if (backdrop?.classList.contains("is-resuming")) return;
    if (!this._readyCheck || !this.net) return;
    const leaveBtn = document.getElementById("mmLeaveBtn");
    if (leaveBtn) leaveBtn.disabled = true;
    this.net.send({ t: "matchleave" });
  }

Game.prototype.setMatchQueueSearching = function (on) {
    this._inMatchQueue = !!on;
    this._mmQueueSince = on ? performance.now() : 0;
    if (on) this.dismissQueueInvite();
    this.updateMatchQueueUI(on ? { players: 0, waiting: 1, matching: 1 } : null);
    document.getElementById("matchmaker")?.querySelectorAll(".seg button, .mode-seg-btn, .mm-category-btn")
      .forEach(el => { el.disabled = on; });
    if (!on) this.syncMmFormatUI();
    this.updateMmQueueCooldownUI();
    this.syncMusic();
  }

Game.prototype.startMatchQueue = function () {
    if (this.rejectIfAlphaClosed()) return;
    if (this._inMatchQueue) return;
    this.dismissQueueInvite();
    if (this.account && this.activeGame) {
      this.showMmError("You're already in a game.");
      return;
    }
    if (this.isMmQueueCooldown()) {
      this.updateMmQueueCooldownUI();
      return;
    }
    const pve = this.mmCategory === "pve";
    const teams = !pve && this.mmFormat === "teams";
    if (pve) {
      if (this.mmPvePlayerSizes.size === 0) {
        this.showMmError("Select at least one player count.");
        return;
      }
    } else if (teams) {
      if (this.mmTeamSizes.size === 0) {
        this.showMmError("Select at least one team size.");
        return;
      }
      if (this.mmTeamCounts.size === 0) {
        this.showMmError("Select at least one team count.");
        return;
      }
    } else if (this.mmPlayerSizes.size === 0) {
      this.showMmError("Select at least one player count.");
      return;
    }
    if (!pve && this.mmModes.size === 0) {
      this.showMmError("Select at least one mode.");
      return;
    }
    this.stopRoomPoll();
    const modes = pve ? ["pve"] : this.mmModesList();
    this._matchmake = pve
      ? {
          format: "pve",
          sizes: this.mmPvePlayerSizesList(),
          modes,
          rounds: this.mmRounds,
          startGold: this.mmStartGold,
        }
      : teams
      ? {
          format: "teams",
          teamSizes: this.mmTeamSizesList(),
          teamCounts: this.mmTeamCountsList(),
          modes,
          rounds: this.mmRounds,
          startGold: this.mmStartGold,
        }
      : {
          format: "ffa",
          sizes: this.mmPlayerSizesList(),
          modes,
          rounds: this.mmRounds,
          startGold: this.mmStartGold,
        };
    track("matchmaker_queue", this._matchmake);
    this.showMmError("");
    this.setMatchQueueSearching(true);
    this.mode = "remote";
    this._intentionalClose = false;
    const name = (document.getElementById("nameInput").value || "").trim();
    const title = equippedTitleId(this.account);
    if (this.net) this.net.close();
    this.net = new Net(this, (m) => this.onServerMsg(m));
    this.net.connect();
    if (pve) {
      this.net.send({ t: "queue", name, title, format: "pve", sizes: this.mmPvePlayerSizesList(), modes });
    } else if (teams) {
      this.net.send({
        t: "queue",
        name,
        title,
        format: "teams",
        teamSizes: this.mmTeamSizesList(),
        teamCounts: this.mmTeamCountsList(),
        modes,
      });
    } else {
      this.net.send({ t: "queue", name, title, sizes: this.mmPlayerSizesList(), modes });
    }
  }

Game.prototype.leaveMatchQueue = function () {
    if (this._readyCheck && this._inMatchQueue && this.net) {
      this.clickMatchLeave();
      return;
    }
    if (!this._inMatchQueue) return;
    this.dismissQueueInvite();
    this._intentionalClose = true;
    if (this.net) {
      this.net.send({ t: "unqueue" });
      this.net.close();
      this.net = null;
    }
    this._inMatchQueue = false;
    this._matchmake = null;
    this.hideReadyCheck();
    this.hideQueueFillModal();
    this.mode = "local";
    this.setMatchQueueSearching(false);
    this.showMmError("");
    this._intentionalClose = false;
    this.ensureMenuNet();
  }

Game.prototype.buildBotSkillSeg = function () {
    const seg = document.getElementById("botSkillSeg");
    const hint = document.getElementById("botSkillHint");
    if (!seg) return;
    seg.innerHTML = "";
    const skill = normalizeBotSkill(this.practiceBotSkill);
    this.practiceBotSkill = skill;
    for (const tier of BOT_SKILLS) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "mode-seg-btn" + (tier.id === skill ? " active" : "");
      b.textContent = tier.label;
      b.title = tier.hint;
      b.onclick = () => {
        Sound.ui();
        this.practiceBotSkill = tier.id;
        [...seg.children].forEach(c => c.classList.remove("active"));
        b.classList.add("active");
        if (hint) hint.textContent = tier.hint;
      };
      seg.appendChild(b);
    }
    if (hint) {
      const cur = BOT_SKILLS.find(t => t.id === skill);
      hint.textContent = cur?.hint || "";
    }
  };

Game.prototype.menuLeaveOpts = function () {
    if (this._fromPractice) return { toSolo: true };
    if (this._fromMatchmaking) return { toMatchmaker: true };
    return { toFind: true };
  }

Game.prototype.matchoverLeaveOpts = function () {
    if (this._fromPractice) return { toSolo: true };
    if (this._fromMatchmaking) return { toMatchmaker: true };
    return {};
  }

Game.prototype.startPractice = function () {
    this.stopRoomPoll();
    this._fromPractice = true;
    this._practice = {
      bots: clamp(this.numPlayers - 1, 1, 7), // numPlayers counts the human too
      botSkill: normalizeBotSkill(this.practiceBotSkill),
      rounds: this.practiceRounds,
      startGold: this.practiceStartGold,
      mode: "normal",
    };
    track("practice_start", {
      bots: this._practice.bots,
      botSkill: this._practice.botSkill,
      rounds: this.practiceRounds,
      startGold: this.practiceStartGold,
    });
    this.goOnline("create");
  }

Game.prototype.startSandbox = function () {
    this.stopRoomPoll();
    this._sandbox = { startGold: 9999 };
    track("sandbox_start");
    this.goOnline("create");
  }
